module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/az-84126238074d3c3c30b970dc95e07324.svg";